import { intlReducer } from "react-intl-redux";
import { type AnyAction, combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";

import { api } from "~/api";
import { isEnglishLocale } from "~/common/locale";
import { devTools } from "~/features/dev-tools/reducer";
import englishMessages from "~/locale/en";
import russianMessages from "~/locale/ru";
import { banners } from "~/slices/banners";
import { bonuses } from "~/slices/bonuses";
import { clinics } from "~/slices/clinics";
import { courseInstallment } from "~/slices/course-installment";
import { instructions } from "~/slices/instructions";
import { services } from "~/slices/services";
import { smartPrescription } from "~/slices/smart_prescription";
import { user } from "~/slices/user";

import {
  clinic,
  delivery,
  doctor,
  doctorPays,
  doctorTasks,
  invoice,
  media,
  media_s3,
  patient,
  patientData,
  patientSaving,
  patients,
  shipments,
  smiles,
  spinner,
  token,
  userActionNotification,
} from "./dashboard";
import { event } from "./events";
import { comments, notifications, notificationWasShown } from "./login";
import { offer } from "./offer";

const appReducer = combineReducers({
  devTools,
  notificationWasShown,
  user,
  token,
  doctor,
  clinic,
  clinics,
  patient,
  patients,
  patientSaving,
  instructions,
  smartPrescription,
  media,
  media_s3,
  comments,
  intl: intlReducer,
  form: formReducer,
  userActionNotification,
  invoice,
  delivery,
  offer,
  patientData,
  courseInstallment,
  services,
  doctorTasks,
  spinner,
  doctorPays,
  bonuses,
  smiles,
  banners,
  shipments,
  event,
  notifications,
  [api.reducerPath]: api.reducer,
});

type AppReducerState = ReturnType<typeof appReducer>;

const rootReducer = (state: AppReducerState | undefined, action: AnyAction): AppReducerState => {
  if (action.type === "CLEAR_STATE") {
    return appReducer(
      {
        intl: isEnglishLocale() ? { locale: "en", messages: englishMessages } : { locale: "ru", messages: russianMessages },
      } as AppReducerState,
      action,
    );
  }
  return appReducer(state, action);
};

export default rootReducer;
